// extracted by mini-css-extract-plugin
module.exports = {"noteContent":"TipCom--noteContent--3cMJXZx","titles":"TipCom--titles--26UbcoI","tit":"TipCom--tit--SP_toEw","more":"TipCom--more--3FNr_oL","newpng":"TipCom--newpng---zuzQLW"};